<p>{{ config.translations.widgetTitle }}</p>
